module.exports = __webpack_public_path__ + "img/LS.07d84b11.svg";